import { NgModule } from "@angular/core"
import { Routes, RouterModule } from "@angular/router"
import { environment } from "src/environments/environment"

const path = environment.LOCAL ? "marketing" : ""

const routes: Routes = [
	{ path, loadChildren: () => import("./components/pages/pages.module").then(m => m.PagesModule) }
]

@NgModule({
	imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "enabled" })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
